export default __webpack_public_path__ + "static/progectImages3-cd9598ee577335f6354beb9df2bf4625.png";